import * as types from "../actions/actionTypes";
import * as eventTypes from "../features/offer/edit/financials/leasingExpenses/eventTypes";
import initialState from "./initialState";

export default function dictionariesReducer(state = initialState.dictionaries, action) {
  switch (action.type) {
    case types.LOAD_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_BANK_ACCOUNT_TYPES_STARTED:
      return {
        ...state,
        bankAccountTypes: { ...state.bankAccountTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED:
      return {
        ...state,
        bankAccountTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_ADDRESS_TYPES_STARTED:
      return {
        ...state,
        addressTypes: { ...state.addressTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_ADDRESS_TYPES_SUCCEEDED:
      return {
        ...state,
        addressTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_SIGNATURE_ROLES_STARTED:
      return {
        ...state,
        signatureRoles: { ...state.signatureRoles, isLoaded: false, loading: true }
      };

    case types.LOAD_SIGNATURE_ROLES_SUCCEEDED:
      return {
        ...state,
        signatureRoles: {
          ...state.signatureRoles,
          items: action.payload,
          isLoaded: true,
          loading: false
        }
      };

    case types.LOAD_VERIFICATION_TYPES_STARTED:
      return {
        ...state,
        verificationTypes: { ...state.verificationTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_VERIFICATION_TYPES_SUCCEEDED:
      return {
        ...state,
        verificationTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_CHECKLISTS_SUCCEEDED:
      return {
        ...state,
        checklists: {
          ...state.checklists,
          items: action.payload,
          isLoaded: true,
          loading: false
        }
      };

    case types.LOAD_INTEREST_TYPES_STARTED:
      return {
        ...state,
        interestTypes: { ...state.interestTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_INTEREST_TYPES_SUCCEEDED:
      return {
        ...state,
        interestTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_GENDER_TYPES_STARTED:
      return {
        ...state,
        genderTypes: { ...state.genderTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_GENDER_TYPES_SUCCEEDED:
      return {
        ...state,
        genderTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_CURRENCIES_STARTED:
      return {
        ...state,
        currencies: { ...state.currencies, isLoaded: false, loading: true }
      };

    case types.LOAD_COMMISSION_TYPES_SUCCESS:
      return {
        ...state,
        commissionTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_COMMISSION_TYPES_STARTED:
      return {
        ...state,
        commissionTypes: { ...state.commissionTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_LEASING_EXPENSE_TYPES_STARTED: {
      const { key } = action;
      let result = {
        ...state,
        leasingExpenseTypes: {
          ...state.leasingExpenseTypes,
          [key]: {
            loading: true,
            loaded: false
          }
        }
      };
      return result;
    }

    case types.LOAD_LEASING_EXPENSE_TYPES_SUCCESS: {
      const newLeasingExpenseTypes = action.response;
      const { key } = action;

      if (!newLeasingExpenseTypes) {
        return state;
      }

      return {
        ...state,
        leasingExpenseTypes: {
          ...state.leasingExpenseTypes,
          [key]: {
            result: [...newLeasingExpenseTypes],
            loading: false,
            loaded: true
          }
        }
      };
    }

    case types.LOAD_STATES_SUCCESS: {
      const key = action.documentTypeId;
      return {
        ...state,
        states: {
          ...state.states,
          [key]: {
            states: [...action.payload.states],
            isLoaded: true
          }
        }
      };
    }

    case types.LOAD_OFFER_VISIBILITY_LEVELS_SUCCESS:
      return {
        ...state,
        offerVisibilityLevels: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_FOLDER_VISIBILITY_LEVELS_SUCCESS:
      return {
        ...state,
        folderVisibilityLevels: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS:
      return {
        ...state,
        partnerFileVisibilityLevels: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_RESPONSIBLES_SUCCESS:
      return {
        ...state,
        responsibles: action.payload
      };

    case types.LOAD_RESPONSIBLE_SUCCESS:
      return {
        ...state,
        responsibles: [...state.responsibles, action.payload]
      };

    case types.LOAD_FINANCING_TYPES_SUCCESS: {
      return {
        ...state,
        financingTypes: { items: Object.assign([], action.payload.financingTypes), isLoaded: true }
      };
    }

    case types.LOAD_OFFER_TYPES_SUCCESS: {
      const key = action.documentTypeId;
      return {
        ...state,
        offerTypes: {
          ...state.offerTypes,
          [key]: {
            offerTypes: [...action.payload.offerTypes],
            isLoaded: true
          }
        }
      };
    }

    case types.LOAD_OFFER_CHANNELS_SUCCESS: {
      return {
        ...state,
        channels: { items: Object.assign([], action.payload.channels), isLoaded: true }
      };
    }

    case types.LOAD_TRANSACTION_CATEGORIES_SUCCESS: {
      return {
        ...state,
        transactionCategories: { items: Object.assign([], action.payload), isLoaded: true }
      };
    }

    case types.LOAD_APPROVAL_TYPES_SUCCESS: {
      return {
        ...state,
        approvalTypes: { items: Object.assign([], action.payload), isLoaded: true }
      };
    }

    case types.LOAD_OFFER_DECISION_TYPES_STARTED:
      return {
        ...state,
        decisionTypes: { ...state.decisionTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_OFFER_DECISION_TYPES_SUCCESS:
      return {
        ...state,
        decisionTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case eventTypes.OFFER_LEASING_EXPENSES_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      const leasingExpenseTypes = { ...state.leasingExpenseTypes };
      delete leasingExpenseTypes[key];
      return { ...state, leasingExpenseTypes: { ...leasingExpenseTypes } };
    }

    case types.LOAD_COMMENTS_CONFIG:
      return {
        ...state,
        commentsConfig: {
          ...state.commentsConfig,
          isLoaded: true,
          list: action.payload
        }
      };

    case types.LOAD_DEALER_SUCCESS:
      return {
        ...state,
        dealers: [...state.dealers, action.payload]
      };

    case types.LOAD_USER_PARTNER_SUCCESS:
      return {
        ...state,
        userPartners: [...state.userPartners, action.payload]
      };

    case types.LOAD_PARTNER_PRIORITIES_SUCCESS:
      return {
        ...state,
        partnerPriorities: { items: Object.assign([], action.payload), isLoaded: true }
      };

    case types.LOAD_WARRANTY_TYPES_STARTED:
      return {
        ...state,
        warrantyTypes: { ...state.warrantyTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_WARRANTY_TYPES_SUCCESS:
      return {
        ...state,
        warrantyTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_OFFER_INVOICING_EXCHANGE_RATES_SUCCESS:
      return {
        ...state,
        invoicingExchangeRates: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_OFFER_INVOICING_EXCHANGE_RATES_STARTED:
      return {
        ...state,
        invoicingExchangeRates: { ...state.invoicingExchangeRates, isLoaded: false, loading: true }
      };

    case types.LOAD_OFFER_REFERENCE_INTERESTS_STARTED:
      return {
        ...state,
        referenceInterests: { ...state.referenceInterests, isLoaded: false, loading: true }
      };

    case types.LOAD_OFFER_REFERENCE_INTERESTS_SUCCESS:
      return {
        ...state,
        referenceInterests: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_SUCCESS:
      return {
        ...state,
        acquisitionExchangeRates: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_OFFER_ACQUISITION_EXCHANGE_RATES_STARTED:
      return {
        ...state,
        acquisitionExchangeRates: { ...state.acquisitionExchangeRates, isLoaded: false, loading: true }
      };

    case types.LOAD_OFFER_CREDIT_FINANCING_LINES_STARTED:
      return {
        ...state,
        creditFinancingLines: { ...state.creditFinancingLines, isLoaded: false, loading: true }
      };

    case types.LOAD_OFFER_CREDIT_FINANCING_LINES_SUCCESS:
      return {
        ...state,
        creditFinancingLines: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_PRICE_TYPES_STARTED:
      return {
        ...state,
        priceTypes: { ...state.priceTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        priceTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_RISK_ANALYSIS_TYPES_STARTED:
      return {
        ...state,
        riskAnalysisTypes: { items: [], isLoaded: false, loading: true }
      };

    case types.LOAD_RISK_ANALYSIS_TYPES_SUCCESS:
      return {
        ...state,
        riskAnalysisTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_INVOICING_BANK_LIST_STARTED:
      return {
        ...state,
        invoicingBankList: { ...state.invoicingBankList, items: [], isLoaded: false, loading: true }
      };

    case types.LOAD_INVOICING_BANK_LIST_SUCCESS:
      return {
        ...state,
        invoicingBankList: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_OFFER_SCHEDULE_TYPES_STARTED:
      return {
        ...state,
        scheduleTypes: { ...state.scheduleTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_PARTNER_LEGAL_FORMS_STARTED:
      return {
        ...state,
        legalForms: { ...state.legalForms, isLoaded: false, loading: true }
      };

    case types.LOAD_PARTNER_LEGAL_FORMS_SUCCESS:
      return {
        ...state,
        legalForms: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_DIMENSION_PERIODS_STARTED:
      return {
        ...state,
        dimensionPeriods: { ...state.dimensionPeriods, isLoaded: false, loading: true }
      };

    case types.LOAD_DIMENSION_PERIODS_SUCCESS:
      return {
        ...state,
        dimensionPeriods: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_SCORING_CATEGORY_OPTIONS_STARTED:
      return {
        ...state,
        scoringCategoryOptions: { ...state.scoringCategoryOptions, isLoaded: false, loading: true }
      };

    case types.LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS:
      return {
        ...state,
        scoringCategoryOptions: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: { items: Object.assign([], action.payload), isLoaded: true }
      };

    case types.LOAD_COUNTIES_SUCCESS:
      return {
        ...state,
        counties: { items: Object.assign([], action.payload), isLoaded: true }
      };

    case types.LOAD_CITIES_SUCCESS:
      return {
        ...state,
        cities: { items: Object.assign([], action.payload), isLoaded: true }
      };

    case types.LOAD_PARTNER_ROLES_STARTED:
      return {
        ...state,
        partnerRoles: { ...state.partnerRoles, isLoaded: false, loading: true }
      };

    case types.LOAD_PARTNER_ROLES_SUCCEEDED:
      return {
        ...state,
        partnerRoles: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_CONTRACT_TYPES_STARTED:
      return {
        ...state,
        contractTypes: { ...state.contractTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_CONTRACT_TYPES_SUCCEEDED:
      return {
        ...state,
        contractTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_ASSET_CATEGORIES_STARTED:
      return {
        ...state,
        assetCategories: { ...state.assetCategories, isLoaded: false, loading: true }
      };

    case types.LOAD_ASSET_CATEGORIES_SUCCEEDED:
      return {
        ...state,
        assetCategories: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_ASSET_CLASSIFICATIONS_STARTED:
      return {
        ...state,
        assetClassifications: { ...state.assetClassifications, isLoaded: false, loading: true }
      };

    case types.LOAD_ASSET_CLASSIFICATIONS_SUCCEEDED:
      return {
        ...state,
        assetClassifications: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    case types.LOAD_PARTNER_POSITIONS_STARTED:
      return {
        ...state,
        partnerPositions: { ...state.partnerPositions, isLoaded: false, loading: true }
      };

    case types.LOAD_PARTNER_POSITIONS_SUCCEEDED:
      return {
        ...state,
        partnerPositions: {
          ...state.partnerPositions,
          items: action.payload,
          isLoaded: true,
          loading: false
        }
      };

    case types.LOAD_CONTACT_MODE_TYPES_STARTED:
      return {
        ...state,
        contactModeTypes: { ...state.contactModeTypes, isLoaded: false, loading: true }
      };

    case types.LOAD_CONTACT_MODE_TYPES_SUCCESS:
      return {
        ...state,
        contactModeTypes: { items: Object.assign([], action.payload), isLoaded: true, loading: false }
      };

    default:
      return state;
  }
}
